// extracted by mini-css-extract-plugin
export default {"ProsItemContainer":"ProsItem_ProsItemContainer__IF7Ct","Icon":"ProsItem_Icon__8HmMh","Text":"ProsItem_Text__xHsBv"};